// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__cunHY","text":"Banner_text__vUuGC","p1":"Banner_p1__uoLgb","p2":"Banner_p2__Uxe0g"};